// src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDiMNNrs0gyv1JRmDMzoZg_M8AlZhVTIzc",
  authDomain: "nicolesarantopoulos-cfff7.firebaseapp.com",
  projectId: "nicolesarantopoulos-cfff7",
  storageBucket: "nicolesarantopoulos-cfff7.firebasestorage.app",
  messagingSenderId: "249495844934",
  appId: "1:249495844934:web:c6a7e756c3710e8b41b247",
  measurementId: "G-52Q2RH5D1V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
